<script>
import { mapGetters } from 'vuex';
import Badge from '../Badge';

export default {
  name: 'XmlChannelStatusCardHeader',
  components: {
    Badge,
  },
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      badges: 'xmlChannelStatus/getBadges',
    }),
  },
};
</script>

<template>
  <v-card-title dark>
    {{ xmlChannel.webservice }}
    <template v-if="xmlChannel.subChannelId">
      <span class="px-1">-</span>
      <span>{{ xmlChannel.subChannelName }}</span>
    </template>
    <v-spacer/>
    <small>{{ xmlChannel.system }}</small>
    <v-spacer/>
    <slot name="tooltip"></slot>
    <badge v-if="xmlChannel.latestJob" :badge="badges[xmlChannel.latestJob.status]"/>
    <badge v-else :badge="badges['NO_CONTENT']"/>
  </v-card-title>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusCardHeader.vue